<template>
  <section>
    <div ref="modalView" class="modal-body">
      <slot></slot>
    </div>
  </section>
</template>

<script>

// ******************************************************
// USAGE
// ******************************************************
// @see https://sweetalert2.github.io/#examples
// ------------------------------------------------------
// import NiceModal from '@tenant/shared/components/NiceModal'
//
// <NiceModal type="info" >
//   <h5>Do Vue variables works dynamically?</h5>
// </NiceModal>
// ------------------------------------------------------

export default {
  components: {
  },
  props: {
    // info, success
    type: { type: String, default: 'info' },
    options: { type: Object, default: () => { return {} } },
    // open: { type: Boolean, default: false }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.log('mounted')
  },
  updated() {
    this.log('updated')
  },
  activated() {
    this.log('activated')
  },
  methods: {
    log(txt) {  },

    getView() {
      return this.$refs['modalView'].innerHTML
    },

    open() {
      swal.fire(Object.assign({
        title: 'Warning',
        html: this.getView(),
        // html: '<div id="modal-view"></div>',
        type: this.type,
        showCloseButton: true,
        showCancelButton: true,
        // onClose: () => this.open = false
      }, this.options))

      // $(this.$refs['modalView'].innerHtml).insertAfter('#modal-view')
    },

    close() {
      swal.close()
    }
  }
}
</script>

<style lang="scss" scoped>
// section {
// display: none;

// // z-index: 1050;
// position: fixed;
// top: 0;
// left: 0;
// width: 100%;
// height: 100%;

// background-color: #222;
// color: #fff;
// font-size: 36px;
// }

.modal-body {
  display: none;
}
</style>
